export const FormDiv = ({ className, children }) => {
  return (
    <div
      className={`[&>div]:flex [&>div]:mb-6 [&>div]:relative [&>div]:flex-col [&>div]:gap-2 ${className}`}
    >
      {children}
    </div>
  );
};
